import { defineMessages } from 'react-intl-next';

export const i18n: {
	confluenceFilterOwnerLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterOwnerLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterOwnerPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	owner: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	owner: {
		id: 'dynamic-cards-search-page.filters.names.owner',
		defaultMessage: 'Owner',
		description:
			'Label for owner filter dropdown shown in search page filters where user can select owner to filter search result by owner',
	},
	confluenceFilterOwnerPlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterOwnerLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterOwnerLabelUnselected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
